import React from 'react';

import { SportIcon } from '../../components/SportIcon/SportIcon';
import type { Athlete } from './types';

import './AthleteCard.css';

type AthleteCardProps = {
    data: Athlete;
    style?: React.CSSProperties;
};

export function AthleteCard({ data, style }: AthleteCardProps) {
    const inner = (
        <React.Fragment>
            <img className="programs-card__bg" src={data.image} alt="" aria-hidden="true" />
            <div className="programs-card__overlay" aria-hidden="true" />
            <div className="programs-card__text">
                <div className="programs-card__sport">
                    <span className="programs-card__sport-label faves-eyebrow--uppercase">{data.sport}</span>
                    <span className="programs-card__sport-icon">
                        {data.sportIconUrl
                            ? <img src={data.sportIconUrl} alt="" loading="lazy" decoding="async" />
                            : <SportIcon iconKey={data.sportIcon ?? 'default'} />}
                    </span>
                </div>
                <h3 className="programs-card__name faves-h3">{data.name}</h3>
            </div>
        </React.Fragment>
    );

    // Cards linked to a real faves athlete open their store; hand-typed names
    // stay a plain article.
    if (data.storeUrl) {
        return (
            <a className="programs-card programs-card--link" style={style} href={data.storeUrl}>
                {inner}
            </a>
        );
    }
    return <article className="programs-card" style={style}>{inner}</article>;
}
